module.exports = __webpack_public_path__ + "img/information-icon.daae5c28.svg";